/** 小型格式化工具 */

export function fmtTime(ms?: number | null): string {
  if (!ms) return '—';
  return new Date(ms).toLocaleString('zh-CN', { hour12: false });
}

export function fmtDate(ms?: number | null): string {
  if (!ms) return '—';
  return new Date(ms).toLocaleDateString('zh-CN');
}

export const ROLE_LABEL: Record<string, string> = {
  admin: '管理员',
  editor: '编辑',
  viewer: '审核员',
};

/** 联系人角色标签内置常用项（与后端全平台标签池合并展示） */
export const CONTACT_ROLE_LABELS = [
  '管理员',
  '采购',
  '品管',
  '工程',
  '研发',
  '生产组长',
  '业务',
  '财务',
  '仓管',
  '客户',
  '供应商',
];
